import { createTestId } from '../../common/selectors';

export const loggedOutPageSelector = createTestId(`logged-out-page`);
